<div class="app-container">
  <page-header [icon]="'far-shopping-cart'" [title]="'purchase.orders'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/purchase-order']"
          [label]="'order.create'"
          [title]="'order.create' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [dataCyAttribute]="'go-create-purchase-order'"
        ></btn>
      }
      <modal-purchase-orders-import
        (onPurchaseOrdersImported)="queryPurchaseOrders.refetch()"
      ></modal-purchase-orders-import>
    </ng-container>
  </page-header>

  @if (!userHavePermissionForThisPage) {
    <section class="content max-width-80">
      <loading-spinner [isLoading]="loading()"></loading-spinner>
      {{ 'purchasePrice.textForUsersWithoutPermission' | translate }}
    </section>
  }
  @if (userHavePermissionForThisPage) {
    <section class="content">
      <app-filter-form
        [isExportButtonShown]="false"
        [filters]="queryFilters()"
        [filtersForExport]="queryFilters()"
        [loading]="areCoreDataLoading()"
        [entity]="'purchaseOrders'"
        [filterVisible]="filtersExpanded"
        [allFilters]="filters()"
        [defaultFilters]="defaultFilters"
        [advancedFilterKeys]="advancedFilterKeys"
        (onSubmit)="this.queryPurchaseOrders.refetch()"
        (onClearClick)="clearFilters()"
        (onExportResult)="queryPurchaseOrders.refetch()"
        [totalItems]="totalItems()"
        [isShowingTags]="true"
      >
        <!--      (onCreateModalHidden)="exportsModal.showChildModal()"-->
        <div class="container-fluid ps-0 pe-0">
          <div class="row">
            <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <form-row-input
                [label]="'fulltext'"
                [icon]="null"
                [model]="filters().fulltext"
                (modelChange)="setFilter('fulltext', $event)"
                (keyup.enter)="this.queryPurchaseOrders.refetch()"
                data-cy="order-name-filter"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'dateCreated.from'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateCreatedFrom"
                (modelChange)="setFilter('dateCreatedFrom', $event)"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'dateCreated.to'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateCreatedTo"
                (modelChange)="setFilter('dateCreatedTo', $event)"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'products.suppliers'"
                [icon]="null"
                [model]="filters().supplier"
                (modelChange)="setFilter('supplier', $event)"
                [options]="suppliersOptions()"
                data-cy="order-process-filter"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'purchase.depot-to'"
                [icon]="null"
                [model]="filters().depot"
                (modelChange)="setFilter('depot', $event)"
                [options]="depotsOptions()"
                data-cy="order-process-filter"
              ></form-row-select>
            </div>
          </div>
          <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
            <div class="row">
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-input
                  [label]="'dateEstimatedArrivalFrom'"
                  [icon]="null"
                  [inputType]="'date'"
                  [model]="filters().dateEstimatedArrivalFrom"
                  (modelChange)="setFilter('dateEstimatedArrivalFrom', $event)"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-input
                  [label]="'dateEstimatedArrivalTo'"
                  [icon]="null"
                  [inputType]="'date'"
                  [model]="filters().dateEstimatedArrivalTo"
                  (modelChange)="setFilter('dateEstimatedArrivalTo', $event)"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select-multiple
                  [label]="'tags'"
                  [options]="queryTagsOptions.data()"
                  [selectedValues]="filters().tags"
                  (selectedValuesChange)="setFilter('tags', $event)"
                  [isTags]="true"
                ></form-row-select-multiple>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select-multiple
                  [label]="'tagsNegate'"
                  [options]="queryTagsOptions.data()"
                  [selectedValues]="filters().tagsNegate"
                  (selectedValuesChange)="setFilter('tagsNegate', $event)"
                  [isTags]="true"
                  [dataCyAttribute]="'purchaseOrders-tagsNegate-filter'"
                ></form-row-select-multiple>
              </div>
              <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
                <form-row-select
                  [label]="'status'"
                  [options]="statusOptions"
                  [model]="filters().status"
                  (modelChange)="setFilter('status', $event)"
                ></form-row-select>
              </div>
            </div>
          </div>
        </div>
      </app-filter-form>
      <app-base-listing
        #baseListingComponent
        [query]="queryPurchaseOrders"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
        [listName]="'purchaseOrders'"
      ></app-base-listing>
    </section>
  }
</div>
